'use strict';

var React = require('react');

var SvgFlipHorizontalIcon = function SvgFlipHorizontalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.445 13.894c-.175.356-.33.669-.43.931-.102.269-.193.59-.14.94.073.473.337.897.73 1.171.29.202.619.262.905.288.28.026.628.026 1.025.026h8.93c.397 0 .745 0 1.025-.026.286-.026.615-.086.905-.288.393-.274.657-.698.73-1.172.053-.349-.038-.67-.14-.939-.101-.262-.255-.575-.43-.931l-4.461-9.083c-.218-.442-.403-.82-.575-1.103-.17-.278-.401-.595-.765-.769-.477-.228-1.031-.228-1.508 0-.364.174-.595.49-.765.77-.172.282-.357.66-.575 1.102l-4.461 9.083Zm1.009 1.805c-.049-.037-.082-.09-.094-.15.002-.016.012-.07.057-.188.072-.19.195-.44.389-.836l4.431-9.02c.237-.484.393-.799.525-1.016.084-.137.132-.19.146-.204.03-.011.06-.017.092-.017v11.482h-4.431c-.44 0-.72 0-.922-.02-.126-.01-.179-.026-.193-.031Z"
  }));
};
SvgFlipHorizontalIcon.displayName = "FlipHorizontalIcon";

exports.SvgFlipHorizontalIcon = SvgFlipHorizontalIcon;
